import {
  AnalysisItem,
  EchartDataType,
  GroupTableType,
  LayerGroupType,
  LocationItem
} from "helpers/models";
import getColor from "report/common/color-rule";

export default (
  groupData: Record<string, Record<string, AnalysisItem[]>>,
  locationItems: LocationItem[],
  legend: LayerGroupType,
  aggregationUnits: string[]
) => {
  const locationMap = Object.fromEntries(
    locationItems.map((item: LocationItem) => [item.id.replaceAll('-', ''), item])
  );

  const groupEchart = aggregationUnits
    .filter((e) => e !== "numberOfLocations")
    .reduce((acc, e) => {
      const gourpLayer = Object.entries(groupData).reduce(
        (acc, [layerId, byValueLabel]) => {
          const valueLabelItem: any[] = [];
          Object.entries(byValueLabel).forEach(([valueLabel, items]) => {
            const sum = items.reduce((acc, i) => {
              if (i.pointId) {
                const locationItem = locationMap[i.pointId.replaceAll('-', '')];
                if (!locationItem) {
                  return 0;
                }
                const agg = locationItem[e as keyof LocationItem];
                if (typeof agg === "number") {
                  return acc + agg;
                }
              }
              return acc;
            }, 0);

            if (sum > 0) {
              valueLabelItem.push({
                label: valueLabel,
                count: sum,
                color: getColor(valueLabel, legend[layerId])
              });
            }
          });

          if (valueLabelItem && valueLabelItem.length > 0) {
            acc[layerId] = valueLabelItem;
          }
          return acc;
        },

        {} as GroupTableType
      );

      acc[e] = gourpLayer;
      return acc;
    }, {} as EchartDataType);

  return groupEchart;
};
